<template>
  <v-app>
    <div v-if="loading" style="height: 100vh">
      <v-layout justify-center align-center style="height: 100%" row>
        <div class="text-xs-center">
          <v-progress-circular
            class="loading"
            size="80"
            :width="4"
            :key="theme.color"
            indeterminate
            :color="theme.color"
          ></v-progress-circular>
        </div>
      </v-layout>
    </div>
    <div v-else>
      <div style="height: 350px">
        <gmap-near-shop
          v-if="showmap"
          :showRadius="false"
          :placesinfo="placesinfolabel"
          v-validate="{ required: true }"
          name="ปักหมุดที่อยู่"
          v-model="gmapvalue"
          v-on:input="gmapLocation"
          :lastordercoords="lastordercoords"
          :error="errors.has('ปักหมุดที่อยู่')"
          :shoplocation="nearest_branch"
          @showShop="showShop"
          :markerImage="'https://assets.zwiz.ai/volvoline/marker.png'"
        ></gmap-near-shop>
      </div>
      <div
        id="nearest_branch_list"
        style="height: calc(100vh - 350px); background: white; overflow-y: auto"
      >
        <template v-for="(shop, index) in nearest_branch">
          <v-layout :key="index">
            <v-flex class="pa-3">
              <div class="title mb-2" :style="{ color: theme.color }">
                {{ shop.name }}
                <v-chip
                  :color="shop.type == 'Workshop' ? 'green' : 'orange'"
                  small
                  disabled
                  class="white--text"
                  >{{
                    shop.type == 'Workshop' ? 'ศูนย์บริการ' : 'ร้านอะไหล่'
                  }}</v-chip
                >
              </div>
              {{ shop.address }}
              <div class="caption mt-1">
                <phonelist v-model="shop.tel"></phonelist>
              </div>
            </v-flex>
            <v-flex shrink class="py-2">
              <v-btn
                small
                fab
                outline
                :color="theme.color"
                :href="shop.link"
                :disabled="shop.link == null || shop.link == ''"
                target="_blank"
              >
                <v-icon>mdi-web</v-icon>
              </v-btn>
            </v-flex>
            <v-flex shrink class="py-2">
              <v-btn
                small
                fab
                outline
                :color="theme.color"
                :href="`${directionGoogleMap}${shop.lat},${shop.long}`"
                target="_blank"
              >
                <v-icon>mdi-google-maps</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-divider :key="`divider_${index}`"></v-divider>
        </template>

        <v-dialog v-model="showCurrentShop" max-width="600">
          <v-card v-if="currentShop">
            <div class="text-xs-right">
              <v-btn
                small
                fab
                flat
                @click="
                  showCurrentShop = false
                  currentShop = null
                "
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </div>
            <v-card-text>
              <div class="title mb-2" :style="{ color: theme.color }">
                {{ currentShop.name }}
                <v-chip
                  :color="currentShop.type == 'Workshop' ? 'green' : 'orange'"
                  small
                  disabled
                  class="white--text"
                  >{{
                    currentShop.type == 'Workshop'
                      ? 'ศูนย์บริการ'
                      : 'ร้านอะไหล่'
                  }}</v-chip
                >
              </div>
              {{ currentShop.address }}
              <div class="caption mt-1">
                <phonelist v-model="currentShop.tel"></phonelist>
              </div>

              <div class="text-xs-center mt-3">
                <v-btn
                  small
                  fab
                  outline
                  :color="theme.color"
                  :href="currentShop.link"
                  :disabled="currentShop.link == null || currentShop.link == ''"
                  target="_blank"
                >
                  <v-icon>mdi-web</v-icon>
                </v-btn>
                <v-btn
                  small
                  fab
                  outline
                  :color="theme.color"
                  :href="`${directionGoogleMap}${currentShop.lat},${currentShop.long}`"
                  target="_blank"
                >
                  <v-icon>mdi-google-maps</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </v-app>
</template>

<script>
import GmapNearShop from '@/components/ecommerce/GmapNearShop.vue'
import { mapGetters } from 'vuex'
import config from '@/config'
import axios from 'axios'

import Phonelist from './Phonelist'
export default {
  data() {
    return {
      loading: false,
      showmap: false,
      gmapvalue: null,
      directionGoogleMap: 'https://maps.google.com/?q=',
      shoplist: [],
      branchlocation: [],
      googlekey: 'AIzaSyA6swf8ou78Zj0LXLK3r1ee2CjKpg5-ePY',
      ggmapdistance: null,
      lastordercoords: null,
      loadingmap: true,
      nearest_branch: [],
      currentShop: null,
      showCurrentShop: false
    }
  },
  components: {
    GmapNearShop,
    Phonelist
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme'
    }),
    pagename: function () {
      return '157480584306735'
    },
    placesinfolabel() {
      return ''
    }
  },
  async mounted() {
    this.loading = true
    await this.$store.dispatch('loadPageProfile', { pagename: this.pagename })
    this.$store.dispatch('updateShopColor', this.pageProfile.shopcolor)
    await this.getbranchlocation()
    this.loading = false
  },
  methods: {
    showShop(shop) {
      this.currentShop = shop
      this.showCurrentShop = true
    },
    getbranchlocation() {
      var vm = this
      return new Promise((resolve) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'branchlocation?pageid=' +
              this.pageProfile.pageid
          )
          .then((response) => {
            if (response.data.responsecode == 200) {
              vm.branchlocation = response.data.branchlocation.map((el) => {
                return {
                  ...el,
                  lat_long: `${el.lat},${el.long}`
                }
              })
              let externalScript = document.createElement('script')
              externalScript.setAttribute(
                'src',
                `https://maps.googleapis.com/maps/api/js?key=${vm.googlekey}&language=th&libraries=places`
              )
              externalScript.async = true
              externalScript.defer = true
              externalScript.onload = () => {
                vm.showmap = true
                resolve()
              }
              document.head.appendChild(externalScript)
              // resolve();
            }
          })
      })
    },
    gmapLocation() {
      var vm = this
      // var locations = [];
      // var nearestlocation;
      // var stringlatlng = this.gmapvalue.lat.toString() + "," + this.gmapvalue.lng.toString();
      // var service = new google.maps.DistanceMatrixService();

      vm.nearest_branch = this.NearestCity(
        this.gmapvalue.lat.toString(),
        this.gmapvalue.lng.toString()
      )
      document.getElementById('nearest_branch_list').scrollTop = 0
      //   var origins = vm.nearest_branch ? vm.nearest_branch.map((el) => el.lat_long) : [];

      //   service.getDistanceMatrix(
      //     {
      //       origins,
      //       destinations: [stringlatlng],
      //       travelMode: "DRIVING",
      //       region: "TH",
      //     },
      //     callback
      //   );

      // function callback(response, status) {
      //   if (status == "OK") {
      //     var bodyjson = response;

      //     for (var i = 0; i < bodyjson.rows.length; i++) {
      //       var row = bodyjson.rows[i].elements[0].distance;

      //       try {
      //         locations.push({
      //           ...vm.nearest_branch[i],
      //           distance: row && row.value ? parseFloat((row.value / 1000).toFixed(2)) : 0,
      //         });
      //       } catch (error) {
      //         console.error(error);
      //       }
      //     }
      //     locations.sort((a, b) => {
      //       var x = parseFloat(a.distance);
      //       var y = parseFloat(b.distance);
      //       return x - y;
      //     });

      //     vm.shoplist = locations;
      //     nearestlocation = locations[0];
      //     //   vm.shippingAddress = response.destinationAddresses[0];
      //     //   vm.placesinfo = response.destinationAddresses[0];
      //     //   vm.ggmapdistance = nearestlocation;
      //     //   var shippingprice = vm.calshippingpricekanom(
      //     //     nearestlocation.distance,
      //     //     vm.totalincludediscount
      //     //   );
      //     //   vm.ableToShipping = shippingprice !== false;
      //     //   vm.kanomshippingprice = vm.ableToShipping ? shippingprice : 0;
      //     //   if (vm.branchlocation && vm.branchlocation.length > 1) {
      //     //     vm.banktransferinfo_photo = nearestlocation.pictureurl;
      //     //   } else {
      //     //     vm.banktransferinfo_photo = vm.mainBankTransferInfoPhoto;
      //     //   }
      //     //   var location_name = vm.shopOptions.find((el) => {
      //     //     return el.includes(nearestlocation.name);
      //     //   });
      //     //   if (location_name) vm.shop = location_name;
      //     // vm.khaiwhanselectedbank = vm.khaiwhanbank.find((el) => el.ref == nearestlocation.name);
      //   } else {
      //     // 400
      //   }
      // }
    },
    PythagorasEquirectangular(lat1, lon1, lat2, lon2) {
      // lat1 = this.Deg2Rad(lat1);
      // lat2 = this.Deg2Rad(lat2);
      // lon1 = this.Deg2Rad(lon1);
      // lon2 = this.Deg2Rad(lon2);
      // var R = 6371; // km
      // var x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
      // var y = lat2 - lat1;
      // var d = Math.sqrt(x * x + y * y) * R;
      // return d;

      var R = 6371 // Radius of the earth in km
      var dLat = this.Deg2Rad(lat2 - lat1) // this.Deg2Rad below
      var dLon = this.Deg2Rad(lon2 - lon1)
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.Deg2Rad(lat1)) *
          Math.cos(this.Deg2Rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      var d = R * c // Distance in km
      return d
    },
    Deg2Rad(deg) {
      return (deg * Math.PI) / 180
    },
    NearestCity(latitude, longitude) {
      var minDif = 99999
      var closest

      var branches = [...this.branchlocation]

      for (var index = 0; index < branches.length; ++index) {
        var dif = this.PythagorasEquirectangular(
          parseFloat(latitude),
          parseFloat(longitude),
          parseFloat(branches[index].lat),
          parseFloat(branches[index].long)
        )
        if (dif < minDif) {
          closest = index
          minDif = dif
        }

        branches[index].dif = dif
      }

      branches.sort((a, b) => {
        var x = parseFloat(a.dif)
        var y = parseFloat(b.dif)
        return x - y
      })
      if (branches.length - 25 > 0) {
        var nearest_branch = branches.splice(0, 25)
        return nearest_branch
      } else {
        return branches
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
